<template>
  <html>
    <head>
      <meta data-n-head="true" charset="utf-8" />
      <meta data-n-head="true" content="width=device-width,initial-scale=1" name="viewport" />
    </head>
    <body>
      <div id="__nuxt">
        <div class="nuxt-progress" style="width:0%;height:2px;background-color:#05939a;opacity:0"></div>
        <div id="__layout">
          <div class="main">
            <header data-v-c76994f4 id="header">
              <div class="main-wrap" data-v-c76994f4>
                <a href="#" class="logo nuxt-link-exact-active nuxt-link-active" data-v-c76994f4>
                  <img alt="Beyond XLH" src="../../assets/logo.60d0bb6.svg" data-v-c76994f4 />
                </a>
              </div>
            </header>
            <div class="content">
              <div class="landing">
                <div class="main-wrap intro clearfix">
                  <div class="intro-content">
                    <h1>
                      Welcome to
                      <img alt="BEYONDXLH" src="../../assets/beyondXLH.dd27f06.png" />
                    </h1>
                    <h3>
                      <p><i>BEYOND</i>XLH is an online disease-monitoring program for patients with X-linked hypophosphatemia (XLH) and other chronic hypophosphatemic disorders.</p>
                      <p>
                        The study is a collaborative research effort among industry (Ultragenyx Pharmaceutical, Inc.), academia (Yale University), and a patient-advocacy group (The XLH Network, Inc.) to characterize XLH and other chronic hypophosphatemic disorders from the patient perspective via a user-friendly mobile application.
                      </p>
                    </h3>
                    <div class="why-should-i">
                      <h3>Why should I sign up?</h3>
                      <p>
                        Every patient counts. Every answer counts. With enough patient participation in
                        <i>BEYOND</i>XLH, we can meet the goals described below.
                      </p>
                    </div>
                    <div class="button-div">
                      <a href="survey.html" class="button button-primary">See if you or your child qualifies</a>
                    </div>
                    <span class="note-continue">SCROLL DOWN TO LEARN MORE</span>
                  </div>
                  <div class="intro-image">
                    <img alt="Mobile" src="../../assets/graphic-header.4b84e45.svg" />
                  </div>
                </div>
                <div class="intro-image-mobile">
                  <img alt="Mobile" src="../../assets/graphic-header.4b84e45.svg" />
                </div>
                <div class="info-blocks" id="promo">
                  <div class="info-block">
                    <div class="wrap-image">
                      <img alt src="../../assets/icn-callout-1.3397d3e.svg" />
                    </div>
                    <div class="wrap">
                      <h2>For You & Your Doctor</h2>
                      <p>
                        Promote long-term engagement of patients and Healthcare Providers (HCPs). Aid efforts to educate newly diagnosed patients and their families.
                      </p>
                    </div>
                  </div>
                  <div class="info-block">
                    <div class="wrap-image">
                      <img alt src="../../assets/icn-callout-2.3179d22.svg" />
                    </div>
                    <div class="wrap-other">
                      <h2>For Treatment Development</h2>
                      <p>
                        Evaluate long-term progression of the disorder. Increase understanding of hypophosphatemic disorders (including XLH) and contribute to the development of new tools and products.
                      </p>
                    </div>
                  </div>
                  <div class="info-block">
                    <div class="wrap-image">
                      <img
                        alt
                        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+CiAgICA8ZyBmaWxsPSIjNDNBMDQ2IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik00My4zOCAxMDBWNzIuMDc4QzM0Ljc3OCA2Ni4zNTUgMTcgNTMuMjk4IDE3IDQ0LjA1NFY0MmgzLjg3MXYyLjA1NGMwIDUuMTM1IDkuODkyIDE1LjExMiAyNS4zNzYgMjUuMzgzbDEuMDA0LjU4NlY5Mmw2LjE2NS00VjcwLjAyM2wuODYtLjU4NmMxNS40ODQtMTAuMjcgMjUuNTItMjAuMjQ4IDI1LjUyLTI1LjM4M1Y0MmgzLjg3djIuMDU0YzAgOS4yNDMtMTcuNzc3IDIyLjMwMS0yNi4zOCAyOC4wMjRWOTBMNDMuMzggMTAweiIvPgogICAgICAgIDxwYXRoIGQ9Ik04NC45MzcgNDUuNzE4SDUxLjU2OXYtNC4wMTZoMzMuMzY4di00LjQ4bC02OC45NS0uMTU0LS4xNDggNC40OCAxNi44MzEuMTU0djQuMDE2SDE1Ljk4NmMtMi4yMTQgMC0zLjk4Ni0xLjg1NC0zLjk4Ni00LjE3di00LjMyNmMwLTIuNDcxIDEuNzcyLTQuMzI1IDMuOTg2LTQuMzI1aDY4Ljk1YzIuMjE1IDAgMy45ODcgMS44NTQgMy45ODcgNC4zMjV2NC4zMjVjMCAyLjMxNy0xLjc3MiA0LjE3LTMuOTg2IDQuMTd6Ii8+CiAgICAgICAgPHBhdGggZD0iTTY3IDIwaDRhNCA0IDAgMCAxIDQgNHY4YTQgNCAwIDAgMS00IDRoLTRhNCA0IDAgMCAxLTQtNHYtOGE0IDQgMCAwIDEgNC00em0wIDE1aDRWMjNoLTR2MTJ6TTQ2IDM1aDRWMjNoLTR6TTMyIDEwaDRhNCA0IDAgMCAxIDQgNHYxMGE0IDQgMCAwIDEtNCA0aC00YTQgNCAwIDAgMS00LTRWMTRhNCA0IDAgMCAxIDQtNHptMCAxNWg0VjEzaC00djEyek0xOCAxNWg0VjBoLTR6TTc5IDE5aDRWMmgtNHpNNTUgMGg0YTQgNCAwIDAgMSA0IDR2MTBhNCA0IDAgMCAxLTQgNGgtNGE0IDQgMCAwIDEtNC00VjRhNCA0IDAgMCAxIDQtNHptMCAxNWg0VjNoLTR2MTJ6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="
                      />
                    </div>
                    <div class="wrap-other">
                      <h2>For Regulators & Payers</h2>
                      <p>
                        Provide real-world data on health care resources and how they are used.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="main-wrap accordion">
                  <div>
                    <div class="paragraph" id="box-0">
                      <h2 class="allowed">Program Details</h2>
                      <div class="box expandable">
                        <div class="accordian-content">
                          <p><i>BEYOND</i>XLH is a non-interventional, prospective, observational disease monitoring program conducted through a mobile/web-based application.</p>
                          <p>
                            The program is designed to encourage patients, their doctors, and researchers to learn more about their disorders across a broad group of patients. Information collected from this diverse population will help patients and clinicians better understand the impact of the disease, improve treatment management, and inform future research.
                          </p>
                          <p>
                            Participation is limited to residents in the United States and Canada. All content is only offered in English at this time. All data will be self-reported by you (or legal guardian-reported if the participant is a minor).
                          </p>
                        </div>
                        <!---->
                        <div class="row">
                          <div class="col buttons">
                            <a href="#" class="button button-light" style="display:none">Previous</a>
                            <a href="#" class="button button-primary">Next</a>
                            <!---->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="paragraph" id="box-1">
                      <h2 class="clickable allowed">What to Expect</h2>
                      <div class="box expandable" style="display:none">
                        <div class="accordian-content">
                          <p><i>BEYOND</i>XLH is a mobile/web-based application. Your information will be collected into a database designed and maintained by Ultragenyx and/or its designees.</p>
                          <p>
                            Following eligibility screening, verification and agreement to consent, participants will register and provide baseline information. Eligibility screening will be conducted by the Yale Center for XLH. Participants (or their caregivers) will be asked to report and enter data via the mobile application.
                          </p>
                          <p>
                            The application will allow participants to enter data at scheduled points of time. You will also have the opportunity to log personal milestones associated with your XLH at any time.
                          </p>
                          <p>
                            Baseline Assessment: You will be prompted to provide information about your demographics and medical history. Expected time to complete: 90 minutes.
                          </p>
                          <p>
                            Interim Interactions (Every 3-4 Months): These interim interactions will be limited and are optional. Expected time to complete: 30 minutes.
                          </p>
                          <p>
                            Annual Assessments: You will be notified approximately every 12 months for additional follow-up questions about your XLH disease progression. Expected time to complete: 60 minutes.
                          </p>
                          <p>
                            Milestones: You can log your XLH-related milestones at any time. Logging events allows you to track your progress over time. Thus, entering additional information may improve your experience in this online DMP. This is optional though and participation is voluntary.
                          </p>
                        </div>
                        <!---->
                        <div class="row">
                          <div class="col buttons">
                            <a href="#" class="button button-light">Previous</a>
                            <a href="#" class="button button-primary">Next</a>
                            <!---->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="paragraph" id="box-2">
                      <h2 class="clickable">Participation and Data Security</h2>
                      <div class="box expandable" style="display:none">
                        <div class="accordian-content">
                          <p><i>BEYOND</i>XLH is a longitudinal disease monitoring program. There are no restrictions on medications or therapies during the course of participation.</p>
                          <p>
                            The
                            <i>BEYOND</i>XLH database will serve as a valuable resource for current and future research. Participants will be able to review their own data collected over time and review general reports on their progress as well as compare their data to de-identified aggregate data. In addition, de-identified, aggregate information may be periodically made available, where
                            appropriate.
                          </p>
                        </div>
                        <!---->
                        <div class="row">
                          <div class="col buttons">
                            <a href="#" class="button button-light">Previous</a>
                            <a href="#" class="button button-primary">Next</a>
                            <!---->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="paragraph" id="box-3">
                      <h2 class="clickable">Getting Started</h2>
                      <div class="box expandable" style="display:none">
                        <div class="accordian-content"></div>
                        <div class="get-started">
                          <p>
                            Now that you have learned about the program, click on the button below to see if you or your child qualifies.
                          </p>
                        </div>
                        <div class="row">
                          <div class="col buttons mt-n45">
                            <a href="#" class="button button-light">Previous</a>
                            <a href="#" class="button button-primary" style="display:none">Next</a>
                            <div class="survey-button">
                              <a href="survey.html" class="button button-primary button-acc-survey">Begin eligibility check</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="new-header-box paragraph">
                      <a href="https://www.ultragenyx.com/" target="_blank">
                        <img alt="AltraGynx" src="../../assets/ugx.f9bd816.svg" class="img1" />
                      </a>
                      <a href="https://www.yale.edu/" target="_blank">
                        <img alt="Yale University" src="../../assets/Yale_logo.9d9c341.svg" class="img3" />
                      </a>
                      <a href="http://xlhnetwork.org/">
                        <img alt="AltraGynx" src="../../assets/xlh-network.8ecb674.svg" class="img2" />
                      </a>
                      <br />
                      <div class="new-header-box-text">
                        Sponsored by Ultragenyx Pharmaceutical and The XLH Network, Inc., in collaboration with Yale University.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="popup-container">
                  <div class="popup">
                    <form class="custom-form" novalidate>
                      <div class="container">
                        <div class="title">Refer a participant</div>
                        <div class="row">
                          <div class="col">
                            <label for="name">
                              Your name
                              <span>*</span>
                            </label>
                            <input name="name" placeholder="Enter Name" />
                            <span class="error" style="display:none"></span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <label for="email">
                              Recipient’s email address
                              <span>*</span>
                            </label>
                            <input name="email" placeholder="Enter Email" type="email" />
                            <span class="error" style="display:none"></span>
                          </div>
                        </div>
                        <div class="rectangle" contenteditable="true">
                          <p>
                            [Enter name] is inviting you to participate in
                            <i>BEYOND</i>XLH.
                          </p>
                          <p><i>BEYOND</i>XLH is an online disease monitoring study for patients with X-linked hypophosphatemia (XLH) or other chronic hypophosphatemic disorder.This study is done completely on your mobile device via a user-friendly mobile application.</p>
                          <p>
                            To learn more, visit
                            <a href="www.BeyondXLH.html" target="_blank"> <i>BEYOND</i>XLH..com </a>.
                          </p>
                        </div>
                        <button class="button button-light">Cancel</button>
                        <button class="button button-primary">Send</button>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="cookie-popup">
                  <div class="close">X</div>
                  <div class="title">Cookie Use Notification</div>
                  <div class="message">
                    The site uses cookies to provide you with a more responsive and personalized service. By using this site you agree to our use of cookies as set out in our
                    <a href="policy.html">privacy policy</a>
                  </div>
                </div>
              </div>
            </div>
            <footer class="footer">
              <div class="main-wrap">
                <div class="left-footer-content">
                  <ul class="footer-navigate">
                    <li>
                      <a href="policy.html">Privacy policy</a>
                    </li>
                    <li>
                      <a href="terms-of-use.html">License Agreement</a>
                    </li>
                    <li>
                      <a href="contact.html">Contact</a>
                    </li>
                  </ul>
                  <div>
                    <p>
                      ©2019 Ultragenyx. All rights reserved. Use of this site is subject to the Internet Site Legal Notices and Disclaimers and Privacy Notice.
                    </p>
                    <p>MRCC-KRN23-00109</p>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </body>
  </html>
</template>
<script>
import axios from "axios";
import { AclRule } from "vue-acl";
import sortBy from "lodash/sortBy";
import { mapGetters } from "vuex";
import { participantStatuses, participantStatusesText, PI, SUB_PI, STUDY_COORDINATOR, HOME_HEALTH, QUALITY, CRA, DM, CraUB } from "@/constants/authRoles";
export default {
  name: "preview-page",
  props: {
    studyData: Object
  },
  data() {
    return {
      globalElements: {
        id: "",
        studyId: "",
        status: "",
        siteTitle: "",
        primaryColor: "",
        secondaryColor: "",
        image_file: "test.png",
        privacyPolicy: "",
        licenseAgreement: "",
        facilityName: "",
        contactName: "",
        contactEmail: "",
        contactPhoneNumber: "",
        contactFaxNumber: "",
        sponsorLogo: ""
      }
    };
  },
  computed: {
    ...mapGetters(["token", "user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    userToken() {
      return this.token;
    },
    studyId() {
      return this.$route.params.studyId;
    },
    getStatuses() {
      return participantStatuses;
    },
    getStatusesText() {
      return participantStatusesText;
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canSubPIAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canDMAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canCRAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    }
  },
  watch: {
    studyData(newData, oldData) {
      if (newData.countryList) {
        this.studyData.countryList = sortBy(newData.countryList, "sortOrder");
      }
      if (newData !== oldData) {
        this.getStudyDetails();
      }
    }
  },
  created() {
    axios({
      url: `http://localhost:3000/api/v1/studymanagement/studies/${this.$route.params.studyId}/web/globalelements`,
      method: "GET"
    })
      .then(response => {
        if (response) {
          this.$store.dispatch("setRwebPreviewDisabled", response.data.data.isReadyToPreview);
          this.globalElements.siteTitle = response.data.data.siteTitle;
          this.globalElements.image_file = response.data.data.studyLogo;
          this.globalElements.primaryColor = response.data.data.primaryColor;
          this.globalElements.secondaryColor = response.data.data.secondaryColor;
          this.globalElements.privacyPolicy = response.data.data.privacyPolicy;
          this.globalElements.contactName = response.data.data.contactName;
          this.globalElements.contactPhoneNumber = response.data.data.contactPhoneNumber;
          this.globalElements.contactFaxNumber = response.data.data.contactFaxNumber;
          this.globalElements.facilityName = response.data.data.facilityName;
          this.globalElements.contactEmail = response.data.data.contactEmail;
        }
      })
      .catch(err => {
        throw err;
      });
  }
};
</script>

<style scoped lang="scss">
body,
html {
  height: 100%;
}

body {
  margin: 0;
  font-size: 14px;
  line-height: 1.43;
  color: #4a4a4a;
  font-family: RobotoRegular;
  background: #fff !important;
}

* {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

#__nuxt {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

#__layout,
#__nuxt {
  height: 100%;
}

h1,
h2,
h3,
h4 {
  line-height: 1.18;
  font-family: Lato-Bold, sans-serif;
}

h2 {
  font-size: 20px;
  color: #05939a;
}

h2,
h3 {
  margin: 0 0 10px;
}

h3 {
  font-size: 18px;
}

.main {
  display: table;
  width: 100%;
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  -webkit-transition: opacity 0.15s;
  transition: opacity 0.15s;
}

.main-wrap {
  width: 100%;
  max-width: 1186px;
  padding: 0 20px;
  margin: 0 auto;
}

@media (max-width: 320px) {
  .main-wrap {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.all-page-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 100vh;
}

.content {
  display: table-row;
  height: 100%;
}

.button {
  display: inline-block;
  width: 260px;
  height: 46px;
  border-radius: 4px;
  font-family: Lato-Bold, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-stretch: normal;
  line-height: 46px;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  margin-top: 5px;
}

.button:disabled {
  opacity: 0.5;
}

.button.button-small {
  min-width: 80px;
  height: 36px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
}

.button.button-light {
  width: 170px;
  height: 46px;
  border: 1px solid #43a046;
  color: #43a046;
  line-height: 46px;
  margin-left: 10px;
}

.button.button-light,
.button.button-light:hover {
  background-color: #fff;
}

.button.button-primary,
.button.button-primary:hover {
  background-color: #43a046;
}

.button:disabled {
  cursor: default;
}

.center-element {
  text-align: center;
}

.clearfix:after {
  content: "";
  display: block;
  clear: both;
}

p {
  margin: 0 0 10px;
}

a {
  color: #6cc3bb;
  text-decoration: none;
}

sup {
  font-size: 0.7em;
}

.custom-form {
  text-align: left;
}

.custom-form h4 {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
  text-align: left;
  color: #004650;
}

.custom-form .col {
  margin-bottom: 12px;
}

.custom-form .row {
  overflow: hidden;
  margin-bottom: 10px;
}

.custom-form .second-column {
  overflow: hidden;
}

.custom-form .second-column .col {
  float: left;
  width: 50%;
  padding-left: 10px;
}

.custom-form .second-column .col:first-child {
  padding-left: 0;
  padding-right: 10px;
}

.custom-form input[type="email"],
.custom-form input[type="number"],
.custom-form input[type="password"],
.custom-form input[type="tel"],
.custom-form input[type="text"],
.custom-form select {
  width: 100%;
  height: 46px;
  padding: 0 8px;
  margin-bottom: 5px;
  border-radius: 4px;
  font-size: 16px;
  background: #fff;
  border: 1px solid #8b8b8b;
  color: #4a4a4a;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: 0;
  -webkit-transition: border 0.25s ease-out;
  transition: border 0.25s ease-out;
}

.custom-form input[type="email"]:active,
.custom-form input[type="email"]:focus,
.custom-form input[type="number"]:active,
.custom-form input[type="number"]:focus,
.custom-form input[type="password"]:active,
.custom-form input[type="password"]:focus,
.custom-form input[type="tel"]:active,
.custom-form input[type="tel"]:focus,
.custom-form input[type="text"]:active,
.custom-form input[type="text"]:focus,
.custom-form select:active,
.custom-form select:focus {
  border: 1px solid #05939a;
  color: #05939a;
}

.custom-form input[type="email"].has-error,
.custom-form input[type="number"].has-error,
.custom-form input[type="password"].has-error,
.custom-form input[type="tel"].has-error,
.custom-form input[type="text"].has-error,
.custom-form select.has-error {
  border-color: #f65b00;
}

.custom-form .custom-select {
  position: relative;
  color: #4a4a4a;
}

.custom-form .custom-select:after {
  content: "";
  position: absolute;
  top: 0;
  right: 10px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto 0;
  border-left: 5px solid transparent;
  border-top: 5px solid;
  border-right: 5px solid transparent;
}

.custom-form .custom-select select {
  padding-left: 8px;
  padding-right: 20px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  text-overflow: ellipsis;
}

.custom-form .custom-select select::-ms-expand {
  display: none;
}

.custom-form .error {
  display: block;
  clear: both;
  font-size: 0.75em;
  line-height: 1;
  color: #f65b00;
}

.custom-form label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
}

.custom-form .group-element {
  margin-bottom: 36px;
}

.custom-form .custom-checkbox input {
  display: none;
}

.custom-form .custom-checkbox input:checked + label:before {
  background-size: 13px 11px;
  background-color: #05939a;
  border-color: #05939a;
}

.custom-form .custom-checkbox label {
  cursor: pointer;
}

.custom-form .custom-checkbox label:before {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  border: 1px solid #8b8b8b;
  border-radius: 3px;
  vertical-align: middle;
}

.custom-form .custom-radio {
  margin-bottom: 13px;
}

.custom-form .custom-radio input {
  display: none;
}

.custom-form .custom-radio input:checked + .label-radio:after {
  content: "";
  display: block;
  position: absolute;
  margin: -16px 0 0 3px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #43a046;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.5);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.5);
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}

.custom-form .custom-radio .label-radio {
  display: inline-block;
  font-size: 17px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #4a4a4a;
}

.custom-form .custom-radio .label-radio:before {
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 10px;
  margin-top: -2px;
  vertical-align: middle;
  border-radius: 50%;
  background-color: rgba(233, 236, 240, 0.5);
  border: 1px solid #c1c1c1;
}

.notification .notification-content {
  font-size: 13px;
  line-height: 1.4;
}

.paragraph {
  max-width: 833px;
  width: 100%;
  margin: 0 auto;
  border-top: 1px solid #d0d0d0;
  text-align: justify;
  padding: 0;
}

.paragraph p {
  font-size: 17px;
  margin-bottom: 20px;
}

.paragraph p:last-child {
  margin-bottom: 0;
}

.paragraph h2 {
  text-align: left;
  margin: 0;
  padding: 15px 0 10px;
}

.paragraph .box {
  background: #fff;
  overflow: hidden;
}

.paragraph .box ul {
  padding-left: 17px;
}

.paragraph .box ul li {
  font-size: 16px;
  line-height: 1.5;
}

.paragraph .clickable.allowed {
  cursor: pointer;
}

@media (max-width: 365px) {
  .paragraph p {
    font-size: 14px;
  }
}

.nuxt-progress {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  width: 0;
  -webkit-transition: width 0.2s, opacity 0.4s;
  transition: width 0.2s, opacity 0.4s;
  opacity: 1;
  background-color: #efc14e;
  z-index: 999999;
}

#header[data-v-c76994f4] {
  margin-top: 40px;
}

#header .logo img[data-v-c76994f4] {
  max-width: 250px;
  margin: 5px 0 0;
}

#header .logo .header-box[data-v-c76994f4] {
  margin-top: 20px;
  width: 200px;
  height: 150px;
  background-color: #f2f2f2;
  border: 1.5px solid #c9c9c9;
}

@media (max-width: 769px) {
  #header .logo .header-box[data-v-c76994f4] {
    width: 160px;
    height: 120px;
  }
}

@media (max-width: 490px) {
  #header[data-v-c76994f4] {
    max-height: 120px;
  }
  #header .logo img[data-v-c76994f4] {
    max-width: 200px;
    margin: 5px 0 0;
  }
}

@media (max-width: 375px) {
  #header .logo .header-box[data-v-c76994f4] {
    width: 120px;
    height: 90px;
  }
}

.cookie-popup {
  position: fixed;
  bottom: 0;
  width: 80%;
  background: #43a046;
  padding: 10px;
  color: #fff;
  margin-left: 10%;
  margin-right: 10%;
  border-radius: 5px;
}

.cookie-popup .close {
  font-size: 12px;
  right: 0;
  text-align: right;
  width: 100%;
  font-weight: 700;
}

.cookie-popup .title {
  font-size: 22px;
  text-align: left;
  padding-left: 5%;
}

.cookie-popup .message {
  padding-left: 5%;
}

.cookie-popup a {
  color: #fff;
  text-decoration: underline;
}

.content {
  overflow: hidden;
}

.intro {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  overflow: hidden;
  padding: 0 22px 0 20px;
  position: relative;
}

.intro-content {
  width: 56%;
  margin-bottom: 20px;
}

.intro-content h1 {
  margin: 0;
  margin-top: 15px;
  font-family: Lato-Bold, sans-serif;
  font-size: 50px;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #6e7a8a;
  max-width: 705px;
}

.intro-content h3 {
  font-family: Lato-Regular, sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #4a4a4a;
  margin: 0;
  margin-top: 5px;
  padding: 0;
}

.intro-content .why-should-i {
  margin-top: 15px;
  margin-bottom: 10px;
}

.intro-content .why-should-i h3 {
  font-family: Lato-Bold, sans-serif;
  font-weight: 700;
  margin-bottom: 5px;
}

.intro-content .why-should-i h3,
.intro-content .why-should-i p {
  font-size: 17px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #4a4a4a;
}

.intro-content .why-should-i p {
  font-family: Lato-Regular, sans-serif;
}

.intro-content .note-continue {
  font-family: Lato-Bold, sans-serif;
  font-size: 17px;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #cbb44b;
  margin-top: 25px;
  margin-bottom: 100px;
  display: block;
}

.intro-image {
  position: absolute;
  right: -95px;
  bottom: -175px;
  z-index: 0;
}

.info-blocks {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-top: 49px;
  margin-bottom: 120px;
  height: 300px;
  background-color: #00524c;
}

.info-block {
  margin: 0 5px -69px;
  padding: 57px 37px 39px;
  border-radius: 8px;
  background-color: #fff;
  -webkit-box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.21);
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.21);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

.info-block img {
  display: block;
  height: 100px;
  margin: 0 auto 34px;
  max-width: 100%;
}

.info-block .wrap {
  display: block;
  width: 100%;
  max-width: 340px;
  margin-left: auto;
  margin-right: auto;
}

.info-block .wrap-other {
  display: block;
  width: 100%;
  max-width: 312px;
  margin-left: auto;
  margin-right: auto;
}

.info-block h2 {
  margin: 0 0 10px;
  font-family: Lato-Bold, sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.4;
}

.info-block h2,
.info-block p {
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4a4a4a;
}

.info-block p {
  font-family: Lato-Regular, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.33;
}

.inline-block {
  display: inline-block;
}

.button-div {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.accordion {
  margin-bottom: 85px;
}

.headline {
  background: #f49416;
  text-align: center;
  color: #fff;
  font: 18px GothamBold, sans-serif;
  padding: 21px;
}

.headline p {
  margin: 0;
}

.intro-image-mobile {
  display: none;
}

@media (max-width: 1350px) {
  .intro-content h3,
  .intro-content p {
    margin-right: 22px;
  }
  .info-block {
    padding: 45px 29px 28px;
  }
}

@media (max-width: 1279px) {
  .intro-content h1 {
    margin-top: 21px;
  }
  .intro-content h3 {
    margin-bottom: 14px;
  }
  .intro-content p {
    margin-bottom: 10px;
  }
}

@media (max-width: 1200px) {
  .intro {
    padding: 0 20px;
  }
  .intro-image {
    right: -75px;
  }
}

@media (max-width: 1040px) {
  .intro-content h1 {
    font-size: 40px;
  }
  .intro-content h1 img {
    height: 30px;
  }
  .info-block h2 {
    font-size: 18px;
  }
  .info-block p {
    font-size: 12px;
  }
  .get-started h2 {
    margin-bottom: 0;
  }
}

@media (max-width: 900px) {
  .intro-content {
    width: 90%;
  }
  .info-blocks {
    position: relative;
  }
  .info-block {
    padding: 31px 28px 18px;
  }
  .info-block h2 {
    font-size: 16px;
  }
  .intro-content .why-should-i p {
    max-width: 450px;
  }
  .intro-image {
    max-width: 310px;
    right: 50px;
    bottom: -115px;
  }
  .intro-image img {
    width: 100%;
  }
}

@media (max-width: 790px) {
  .intro-content {
    width: 100%;
  }
  .intro-content h1 {
    font-size: 50px;
  }
  .intro-content h1 img {
    height: 40px;
  }
  .intro-content .why-should-i {
    max-width: 490px;
  }
  .intro-content .note-continue {
    margin-bottom: 96px;
  }
  .intro-image {
    max-width: 290px;
    right: 20px;
    bottom: -105px;
  }
  .info-blocks {
    display: block;
    margin-bottom: 90px;
    padding: 39px 20px 1px;
    height: 440px;
  }
  .info-block {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: auto;
    height: 140px;
    margin: 0 0 10px;
    padding: 25px 20px;
    text-align: left;
    max-width: 688px;
    margin: auto;
    margin-bottom: 10px;
  }
  .info-block:last-child {
    margin-bottom: -26px;
  }
  .info-block p {
    text-align: left;
  }
  .info-block .wrap-image {
    width: 100px;
    height: 100px;
    margin-right: 11px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100px;
    flex: 0 0 100px;
  }
  .info-block .wrap-other,
  .info-block .wrap {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    margin: 0;
    max-width: 450px;
  }
  .info-block h2 {
    text-align: left;
  }
  .info-block img {
    margin-bottom: -9%;
  }
}

@media (max-width: 768px) {
  .intro-image {
    max-width: 300px;
    right: 10px;
    bottom: -110px;
  }
  .info-block h2 {
    font-size: 20px;
  }
  .info-block p {
    font-size: 15px;
  }
}

@media (max-width: 750px) {
  .intro-image {
    display: none;
  }
  .intro-image-mobile {
    display: block;
    max-width: 400px;
    margin: auto;
    text-align: center;
    margin-bottom: -150px;
  }
  .intro-image-mobile img {
    width: 100%;
  }
}

@media (max-width: 670px) {
  .intro-content {
    margin-bottom: 0;
  }
  .intro-content .note-continue {
    margin-bottom: 75px;
  }
}

@media (max-width: 630px) {
  .intro-content h1 img {
    height: 35px;
  }
}

@media (max-width: 590px) {
  .intro-content h1 {
    font-size: 40px;
  }
  .intro-content h1 img {
    height: 30px;
  }
}

@media (max-width: 490px) {
  .button-div {
    display: block;
  }
  .button.button-light {
    display: block;
    margin: 0;
    margin-top: 15px;
  }
  .intro-content h1 {
    font-size: 30px;
  }
  .intro-content h1 img {
    height: 20px;
  }
  .info-block {
    padding: 25px 10px;
  }
  .info-block h2 {
    font-size: 16px;
  }
  .info-block p {
    font-size: 12px;
  }
}

@media (max-width: 400px) {
  .intro-image-mobile {
    max-width: 95%;
    margin-bottom: -130px;
  }
}

@media (max-width: 375px) {
  .intro {
    padding: 0 16px;
  }
  .intro-content h1 {
    margin-top: 0;
  }
  .intro-content .why-should-i {
    margin-bottom: 20px;
  }
  .intro-content .note-continue {
    margin: 36px 0 40px;
  }
  .info-blocks {
    height: 700px;
    padding: 40px 16px 1px;
    margin-bottom: 100px;
  }
  .info-block .wrap-image {
    display: inline;
    display: initial;
    float: none;
    margin: auto;
  }
  .info-block img {
    display: block;
    height: 80px;
    margin: 0 auto 10px;
    max-width: 80%;
  }
  .info-block {
    display: block;
    text-align: center;
    height: 230px;
    max-width: 343px;
  }
  .info-block h2 {
    text-align: center;
    margin-bottom: 11px;
    line-height: 1.2;
    font-size: 20px;
  }
  .info-block p {
    font-size: 15px;
    text-align: center;
  }
}

@media (max-width: 365px) {
  .intro-content h1 {
    font-size: 24px;
  }
  .intro-content .why-should-i h3,
  .intro-content .why-should-i p,
  .intro-content h3 {
    font-size: 14px;
  }
  .info-block h2 {
    font-size: 16px;
  }
  .info-block p {
    font-size: 12px;
  }
  .intro-image-mobile {
    margin-bottom: -125px;
  }
}

@media (max-width: 340px) {
  .intro-image-mobile {
    margin-bottom: -115px;
  }
}

@media (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .intro-image {
    right: -45px;
    bottom: -190px;
  }
}

@media screen and (-webkit-min-device-pixel-ratio: 0) {
  .intro-image img {
    width: 90%;
  }
}

.paragraph h2 {
  font-family: Lato-Bold, sans-serif;
  font-size: 20px;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: #00524c;
}

.box .accordian-content {
  font-family: Lato-Regular, sans-serif;
  font-size: 17px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #4a4a4a;
}

.buttons {
  text-align: left;
  margin: 10px 0 30px;
  overflow: hidden;
}

.buttons .button {
  width: 150px;
  height: 46px;
}

.buttons .button.button.button-light {
  margin-left: 0;
  margin-right: 10px;
}

.get-started p {
  font-family: Lato-Regular, sans-serif;
  font-size: 17px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #4a4a4a;
  margin-bottom: 20px;
}

.survey-button {
  display: inline-block;
}

.survey-button .button {
  width: 200px;
}

.inline-block {
  display: inline-block;
}

.button {
  min-width: 160px;
}

@media (max-width: 900px) {
  .buttons {
    margin: 21px 0 28px;
  }
}

@media (max-width: 600px) {
  .get-started {
    margin-bottom: -72px;
  }
}

@media (max-width: 440px) {
  .get-started {
    margin-bottom: 24px;
  }
  .get-started .button {
    display: block;
  }
}

@media (max-width: 365px) {
  .accordian-content {
    font-size: 14px;
  }
}

.home-slide-enter-active,
.home-slide-leave-active {
  -webkit-transition: max-height 0.8s, opacity 1s ease-in-out;
  transition: max-height 0.8s, opacity 1s ease-in-out;
}

.home-slide-enter,
.home-slide-leave-to {
  opacity: 0;
  max-height: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.home-slide-enter-to,
.home-slide-leave {
  max-height: 2000px;
  opacity: 1;
}

.popup-container {
  top: 0;
  left: 0;
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: none;
}

.popup-container.active {
  display: block;
}

.popup-container .popup {
  position: fixed;
  display: none;
  width: 100%;
  margin: auto;
  height: 520px;
  background: #fff;
  color: #3d3f42;
  -webkit-box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.21);
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.21);
  border-radius: 8px;
  text-align: center;
  max-width: 600px;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.popup-container .popup.active {
  display: block;
}

.popup-container .popup .custom-form {
  text-align: center;
}

.popup-container .popup .container {
  padding: 20px 30px;
}

.popup-container .popup .container .title {
  font-size: 20px;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: #4a4a4a;
  text-align: left;
}

.popup-container .popup .container .row {
  margin-top: 15px;
  overflow: hidden;
}

.popup-container .popup .container .row .col {
  margin-bottom: 10px;
}

.popup-container .popup .container .row .col label {
  font-size: 17px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #4a4a4a;
  margin-bottom: 4px;
  display: block;
  text-align: left;
}

.popup-container .popup .container .row .col label span {
  color: #e35c5c;
}

.popup-container .popup .container .row .col input[type="email"],
.popup-container .popup .container .row .col input[type="text"] {
  width: 100%;
  height: 40px;
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000;
  margin-top: 5px;
  padding-left: 10px;
  font-family: Lato-Regular, sans-serif;
  display: block;
  border-radius: 3px;
  background-color: #fff;
  border: 1px solid #cecfd2;
  outline: 0;
}

.popup-container .popup .container .row .col input[type="email"].has-error,
.popup-container .popup .container .row .col input[type="text"].has-error {
  border-color: #e35c5c;
}

.popup-container .popup .container .row .col input[type="email"]:active,
.popup-container .popup .container .row .col input[type="email"]:focus,
.popup-container .popup .container .row .col input[type="text"]:active,
.popup-container .popup .container .row .col input[type="text"]:focus {
  border: 1px solid #cecfd2;
}

.popup-container .popup .container .row .col input[type="email"]::-webkit-input-placeholder,
.popup-container .popup .container .row .col input[type="text"]::-webkit-input-placeholder {
  color: #cecfd2;
}

.popup-container .popup .container .row .col input[type="email"]:-ms-input-placeholder,
.popup-container .popup .container .row .col input[type="email"]::-ms-input-placeholder,
.popup-container .popup .container .row .col input[type="text"]:-ms-input-placeholder,
.popup-container .popup .container .row .col input[type="text"]::-ms-input-placeholder {
  color: #cecfd2;
}

.popup-container .popup .container .row .col input[type="email"]::placeholder,
.popup-container .popup .container .row .col input[type="text"]::placeholder {
  color: #cecfd2;
}

.popup-container .popup .container .row .col .error {
  display: none;
  margin: 0;
  color: #dc3545;
  text-align: left;
}

.popup-container .popup .container .rectangle {
  width: 100%;
  height: 200px;
  border-radius: 3px;
  background-color: #f5f5f5;
  border: 1px solid #cecfd2;
  padding: 10px;
}

.popup-container .popup .container .rectangle p {
  opacity: 0.7;
  font-family: Lato;
  font-size: 17px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #4a4a4a;
  text-align: left;
  margin-bottom: 20px;
}

.popup-container .popup .container .rectangle p a {
  color: #4a90e2;
}

.popup-container .popup .container .button-light {
  width: 150px;
  height: 46px;
  background-color: #fff;
  color: #43a046;
  border: 1px solid #43a046;
  -webkit-box-shadow: none;
  box-shadow: none;
  margin-top: 20px;
}

.popup-container .popup .container .button-primary {
  width: 150px;
  height: 46px;
  background-color: #43a046;
  border: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  margin-left: 10px;
  margin-top: 20px;
}

.popup-container .popup .container .notification-box {
  background: #fff;
  font-size: 17px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  border: 1px solid #000;
  border-radius: 3px;
}

@media (max-width: 620px) {
  .popup-container .popup {
    width: 90%;
    height: 600px;
  }
  .popup-container .popup .container .rectangle {
    height: 280px;
  }
}

@media (max-width: 425px) {
  .popup-container .popup {
    width: 92%;
  }
  .popup-container .popup .container {
    padding: 20px;
  }
  .popup-container .popup .container .button-light {
    margin-left: 0;
  }
  .popup-container .popup .container .button-primary {
    margin-left: 5px;
  }
}

@media (max-width: 374px) {
  .popup-container .popup .container {
    padding: 16px;
  }
  .popup-container .popup .container .rectangle p {
    font-size: 15px;
  }
  .popup-container .popup .container .button-light,
  .popup-container .popup .container .button-primary {
    width: 125px;
    height: 40px;
    line-height: 40px;
  }
}

.footer {
  display: table-row;
  height: 0;
  font-size: 12px;
  line-height: 1.33;
  background-color: #00524c;
  color: #fff;
}

.footer .main-wrap {
  padding-top: 43px;
  padding-bottom: 26px;
  overflow: hidden;
}

.footer a {
  color: #fff;
  text-decoration: none;
}

.footer a:hover {
  text-decoration: none;
}

.footer .logo {
  float: right;
  max-width: 137px;
}

.footer .logo img {
  max-width: 100%;
}

.footer p {
  margin: 0;
}

.footer .left-footer-content {
  font-family: Lato-Regular, sans-serif;
  font-size: 13px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  float: left;
  max-width: 675px;
  line-height: 18px;
}

.footer .left-footer-content p {
  font-size: 13px;
}

.footer .new-header-box {
  float: right;
  margin-top: -65px;
}

.footer .new-header-box img {
  display: inline-block;
  // float: right
}

.footer .new-header-box .img1 {
  margin: 0;
}

.footer .new-header-box .img2 {
  margin-top: 50px;
  margin-left: 20px;
}

.footer .new-header-box .img3 {
  width: 90px;
  margin-top: 60px;
  margin-left: 20px;
  height: 45px;
}

.footer .new-header-box-text {
  font-size: 13px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #fff;
  float: right;
  width: 358px;
  margin-top: 0;
  clear: both;
  right: 0;
}

.footer .new-header-box:after {
  clear: both;
}

.footer .header-box-top {
  display: none;
}

.footer .footer-navigate {
  display: block;
  margin: 0 0 14px;
  padding: 0;
  list-style: none;
}

.footer .footer-navigate li {
  display: inline-block;
  margin-right: 43px;
}

@media (max-width: 947px) {
  .footer .new-header-box {
    margin-top: 0;
    width: 100%;
    float: left;
  }
  .footer .new-header-box-text {
    margin-top: -20px;
    width: 100%;
    float: left;
    text-align: left;
  }
}

@media (max-width: 769px) {
  .footer .left-footer-content {
    max-width: 90%;
  }
}

@media (max-width: 640px) {
  .footer .new-header-box img {
    width: 150px !important;
    margin-right: 20px !important;
    margin-bottom: 20px !important;
  }
  .footer .new-header-box .img3 {
    width: 80px !important;
    margin-top: 40px;
    margin-left: 0;
  }
  .footer .new-header-box .img2 {
    margin-top: 25px;
    margin-left: 0;
  }
}

@media (max-width: 550px) {
  .footer .main-wrap {
    padding: 30px 20px 29px;
  }
  .footer .left-footer-content {
    float: none;
    width: auto;
    margin-top: 20px;
    max-width: 100%;
  }
  .footer .logo {
    display: block;
    float: none;
  }
  .footer .header-box-top {
    width: 200px;
    height: auto;
    float: none;
    margin-top: -40px;
    display: block;
  }
  .footer .new-header-box img {
    width: 120px !important;
  }
  .footer .new-header-box .img3 {
    width: 70px !important;
  }
}

@media (max-width: 460px) {
  .footer .new-header-box img {
    width: 100px !important;
    margin-bottom: 40px !important;
  }
  .footer .new-header-box .img3 {
    width: 50px !important;
  }
}

@media (max-width: 399px) {
  .footer .new-header-box-text,
  .footer .new-header-box {
    margin-top: 0;
  }
  .footer .new-header-box {
    text-align: center;
    float: none;
    display: inline-grid;
  }
  .footer .new-header-box img {
    width: 150px !important;
  }
  .footer .new-header-box .img1 {
    margin-bottom: 0 !important;
  }
  .footer .new-header-box .img3 {
    width: 90px !important;
    margin-top: -15px !important;
    margin-left: 10px;
  }
  .footer .new-header-box .img2 {
    margin-top: -25px !important;
    margin-bottom: 0 !important;
  }
}
.new-header-box-text {
  color: #959fa4;
}
</style>
